/**
 * Permissions enum - dupe of server permissions enum
 */
export enum PermissionItem {
    SystemAdministrator,
    RecordsManager,
    AdministrationApplications,
    AdministrationArchives,
    AdministrationAutologoff,
    AdministrationDatasources,
    AdministrationDevices,
    AdministrationDirectories,
    AdministrationFields,
    AdministrationLookupTables,
    AdministrationMicrofilm,
    AdministrationModules,
    AdministrationScanner,
    AdministrationSoftforms,
    AdministrationTemplates,
    AdministrationUserExits,
    AdministrationUsersGroups,
    DataEntryClassic,
    DataEntryFile360Folder,
    DataEntryFile360File,
    DataEntryConvertFolder,
    DataEntrySkipDocument,
    DataEntryDeleteFolder,
    DocumentDelete,
    DocumentDestroy,
    DocumentIndexModifyGrid, // Index modify via grid
    DocumentIndexModifyTemplate, // Index modify via template
    DocumentPageModify,
    DocumentAnnotate,
    DocumentVersionManagement,
    GlobalAdministrationPrepareWrite,
    GlobalDatabaseEngineExecute,
    GlobalDatabaseEngineModifySettings,
    GlobalInBasketRequestOperator,
    GlobalLookupTableModification,
    GlobalReportViewing,
    GlobalSystemLanguageSelection,
    GlobalSystemVersionControl,
    GlobalSystemPersonalFilingSystem,
    GlobalTemplatesModification,
    GlobalAllowUserChangePassword,
    GlobalAllowMustSeeAnnotation,
    GlobalFreeFolders,
    EnableExternalViewer,  // This is special because it is from the USS table, not the COMSEC field in the USR table.
    ContentServer,         // This permisson item is based on a system key module.
    GlobalImport,
    GlobalExport,
    MailExternalMailing,
    MailFolderSendExternalDocuments,
    MailFolderSendInternalDocuments,
    RemarksAppend,
    RemarksRead,
    RemarksDelete,
    RemarksModify,
    RetrievalDataExport,
    RetrievalPrintDocuments,
    RetrievalRetrieve,
    SpecialAPIEntryFolderExport,
    SpecialAPIEntryFolderImport,
    SpecialAPIRetrievalFolderExport,
    SpecialAPIRetrievalFolderImport,
    MicrofilmPrintRequest,
    MicrofilmFaxRequest,
    MicrofilmFolderRequest,
    WorkflowParticipant,
    WorkflowStatus
}
